module.exports = __webpack_public_path__ + "img/WEILINGTON_icon.e836f133.png";